import React from 'react';
interface RegistrationFormProps {
  idPrefix?: string;
  className?: string;
}
const FORM_ID = 'zEjpFsBBM2nZ4uxKgIJ7';
export function RegistrationForm({
  idPrefix = 'reg',
  className = ''
}: RegistrationFormProps) {
  const iframeId = `inline-${FORM_ID}-${idPrefix}`;
  return <div className={className} data-id="element-117">
      <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} id={iframeId} title="Formulario de Registro - Cumbre de Inversión" scrolling="no" className="block w-full rounded-xl" style={{
      width: '100%',
      height: '240px',
      border: 'none',
      background: 'transparent'
    }} data-layout='{"id":"INLINE"}' data-trigger-type="alwaysShow" data-form-id={FORM_ID} data-form-name="Registro Cumbre" data-id="element-118" />
    </div>;
}